@let isLoading =
  clustersEc.plugins.currentEntityPlugin.feature.selectors
    .isLoading()
    .asSignal();

<atn-ds-widget title="General">
  <ng-container actions>
    <button
      class="atn-cluster-general__edit-button"
      [disabled]="isLoading"
      (click)="editClickHandler()"
    >
      <i class="atn-icon atn-edit atn-blue"></i>
    </button>
  </ng-container>

  @if (isLoading) {
    <div class="atn-cluster-general__loader">
      <atn-ds-loader />
    </div>
  } @else {
    <div class="atn-cluster-general__section">
      <div class="atn-cluster-general__field">
        <span><b>Name</b></span>
        <atn-ds-value [value]="clusterNameSg()" />
      </div>

      <div class="atn-cluster-general__field">
        <span><b>Description</b></span>
        <atn-ds-value [value]="clusterDescriptionSg()" />
      </div>

      @let orgs = organizationDataSg();
      @for (org of orgs; track org.id) {
        <div class="atn-cluster-general__field">
          <span
            ><b>{{ org.name }}</b></span
          >
          <atn-ds-value [value]="org.value" />
        </div>
      }
      @if (clusterCommentSg(); as comment) {
        <div
          class="atn-cluster-general__field atn-cluster-general__field--full-width"
        >
          <span><b>Comment</b></span>
          <atn-ds-value [value]="comment" />
        </div>
      }
    </div>
  }
</atn-ds-widget>
